export const isAuthenticated = (user: any) => !!user;

export const hasPermission = (user: any, permissions: any) =>
  permissions.some((permission: any) => user._role.rolePermission.find((perm: any) => perm._permission.name === permission));

export const hasRole = (user: any, roles: any) =>
  roles?.some((role: any) => user?._role?.code === role);